import React from "react";
import RespondentTerminalPage from "../components/ending/RespondentTerminalPage";

const SecurityTerminateV2 = () => {
  return (
    <RespondentTerminalPage
      variant="security-terminate"
      message="We were unable to verify your session. Your response could not be accepted."
    />
  );
};

export default SecurityTerminateV2;
